module.exports = __webpack_public_path__ + "static/media/ideal_devis.f6163306.png";